import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CryptNoble2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CRYPT_NOBLE2;
}

export default CryptNoble2PoiTileEntity;
